// Every routed page and the roles that can reach it by default.
// Superadmins can switch pages on/off per role and per person (stored in
// app_settings/access), but never beyond a role's defaults — Firestore rules
// would block the data those pages need anyway.
export const PAGES = [
  { path: "/dashboard",         label: "Dashboard",       roles: ["viewer", "admin", "superadmin"] },
  { path: "/analytics",         label: "Analytics",       roles: ["superadmin"] },
  { path: "/ai-assistant",      label: "Ask AI",          roles: ["admin", "superadmin"] },
  { path: "/financials",        label: "Reconciliation",  roles: ["viewer", "admin", "superadmin"] },
  { path: "/expenses",          label: "Expenses",        roles: ["viewer", "admin", "superadmin"] },
  { path: "/creditors",         label: "Creditors",       roles: ["viewer", "admin", "superadmin"] },
  { path: "/lubes",             label: "Lubricants",      roles: ["viewer", "admin", "superadmin"] },
  { path: "/reports",           label: "Reports",         roles: ["viewer", "admin", "superadmin"] },
  { path: "/business-setup",    label: "Business Setup",  roles: ["superadmin"] },
  { path: "/maintenance",       label: "Maintenance",     roles: ["admin", "superadmin"] },
  { path: "/maintenance-setup", label: "Maint. Setup",    roles: ["superadmin"] },
  { path: "/employees",         label: "Employees",       roles: ["admin", "superadmin"] },
  { path: "/admin",             label: "Data Entry",      roles: ["admin", "superadmin"] },
  { path: "/profile",           label: "Profile",         roles: ["viewer", "admin", "superadmin"], alwaysOn: true },
];

// Roles whose page access a superadmin can configure.
export const CONFIGURABLE_ROLES = [
  { key: "admin",  label: "Admins" },
  { key: "viewer", label: "Users" },
];

export const DEFAULT_ACCESS_SETTINGS = {
  disabledPages: { admin: [], viewer: [] },
  // Per-person exceptions: { [uid]: { [path]: true | false } } — beats the role setting.
  userOverrides: {},
  adminBacklogEntry: false,
};

// Whether the page is on for this role before any per-person exception.
export const roleSettingAllows = (role, path, settings) =>
  !(settings?.disabledPages?.[role] || []).includes(path);

export const canRoleAccessPage = (role, path, settings, uid) => {
  const page = PAGES.find(p => p.path === path);
  if (!page) return true; // unlisted routes (login, not-found, …) aren't gated here
  if (!role || !page.roles.includes(role)) return false;
  if (role === "superadmin" || page.alwaysOn) return true;
  const override = uid ? settings?.userOverrides?.[uid]?.[path] : undefined;
  if (typeof override === "boolean") return override;
  return roleSettingAllows(role, path, settings);
};

// Where to send a user who lands on a page they can't open.
export const firstAccessiblePage = (role, settings, uid) => {
  const page = PAGES.find(p => canRoleAccessPage(role, p.path, settings, uid));
  return page ? page.path : "/profile";
};
